import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'
import { i18nOptions } from './config/i18n'

i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init(i18nOptions)

export default i18n
